import { Brand, Schema } from "effect";
import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "effect/http-api";

export type ClientId = string & Brand.Brand<"ClientId">;
export const ClientId = Brand.nominal<ClientId>();
export const ClientIdSchema = Schema.String.pipe(Schema.fromBrand("ClientId", ClientId));

export type TenantId = string & Brand.Brand<"TenantId">;
export const TenantId = Brand.nominal<TenantId>();
export const TenantIdSchema = Schema.String.pipe(Schema.fromBrand("TenantId", TenantId));

export const ActiveClientSchema = Schema.Struct({
  name: Schema.String,
  clientId: ClientIdSchema,
  tenantId: TenantIdSchema,
  zapierClientId: Schema.OptionFromNullOr(Schema.String),
});

export const ActiveClientsResponseSchema = Schema.Array(ActiveClientSchema);

export const ClientsV3Group = HttpApiGroup.make("clientsV3").add(
  HttpApiEndpoint.get("getActiveClients", "/clients/active", {
    success: ActiveClientsResponseSchema,
    error: HttpApiError.InternalServerErrorNoContent,
  })
);
